export const CONFIRM_MODAL_SET_PARAMS = 'CONFIRM_MODAL_SET_PARAMS';
export const CONFIRM_MODAL = 'CONFIRM_MODAL';
export const CONFIRM_MODAL_RESET = 'CONFIRM_MODAL_RESET';
export const CONFIRM_MODAL_SUCCESS = 'CONFIRM_MODAL_SUCCESS';
export const CONFIRM_MODAL_FAIL = 'CONFIRM_MODAL_FAIL';